import { useEffect } from 'react';

/**
 * Custom hook to set page-specific document titles
 * Usage: useDocumentTitle('Comics') -> "Comics – Trap Comix"
 * Usage: useDocumentTitle() -> "Trap Comix"
 */
export const useDocumentTitle = (pageTitle) => {
  useEffect(() => {
    const baseTitle = 'Trap Comix';
    document.title = pageTitle ? `${pageTitle} – ${baseTitle}` : baseTitle;
    
    // Cleanup: reset to base title when component unmounts
    return () => {
      document.title = baseTitle;
    };
  }, [pageTitle]);
};

/**
 * Set document title imperatively (for non-hook contexts)
 */
export const setDocumentTitle = (pageTitle) => {
  const baseTitle = 'Trap Comix';
  document.title = pageTitle ? `${pageTitle} – ${baseTitle}` : baseTitle;
};

export default useDocumentTitle;
